<template>
  <div class="splitimg">
    <div class="show-msg">
      <span class="title">{{showMsg.title}}</span>
      <div>
        <div>
          Time:
          <el-tag type="danger" effect="plain">
            {{loadedTime/1000.0}}s
          </el-tag>
        </div>
        <div>
          Load image count:
          <el-tag type="danger" effect="plain">
            {{loadedCount}}
          </el-tag>
        </div>
      </div>
    </div>
    <div class="row" v-for="n in colCount">
      <img v-for="row in rowCount" :src="baseUrl + fillZero((n-1)*20 + row) + '.png?' + randomVal" :width="imgWidth" :height="imgWidth" @load="imgOnLoad" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: "SplitImg",
    props: ['baseUrl', 'showMsg'],
    data() {
      return {
        baseUrlBak: '/static/lsimg/lsimg_',
        colCount: 20,
        rowCount: 20,
        defaultColCount: 20,
        defaultRowCount: 20,
        imgWidth: 18,
        startTime: null,
        loadedCount: 0,
        loadedTime: 0,
        randomVal: Math.random(),
        timeInterval: null,
        plusMils: 10
      }
    },
    created () {
    },
    methods: {
      fillZero (num) {
        if (parseInt(num) < 10) {
          return '0' + num
        }
        return num
      },
      imgOnLoad () {
        this.loadedCount++
        if (this.loadedCount === this.colCount * this.rowCount) {
          clearInterval(this.timeInterval)
          this.loadedTime = new Date().getTime() - this.startTime.getTime()
        }
      },
      resetImg () {
        clearInterval(this.timeInterval)
        this.rowCount = 0
        this.colCount = 0
        setTimeout(() => {
          this.rowCount = this.defaultRowCount
          this.colCount = this.defaultColCount
          this.startIntervalTime()
        }, 0.2 * 1000)
      },
      reload () {
        this.resetImg()
        this.startTime = new Date()
        this.loadedCount = 0
        this.loadedTime = 0
        this.randomVal = Math.random()
      },
      increaseTime () {
        this.loadedTime += this.plusMils
      },
      startIntervalTime () {
        this.timeInterval = setInterval(this.increaseTime, this.plusMils)
      }
    },
    mounted() {
      this.startTime = new Date()
      this.startIntervalTime()
    },
    beforeDestroy () {
      clearInterval(this.timeInterval)
    }
  }
</script>

<style scoped>
  .splitimg {
    text-align: center;
  }
  .splitimg .show-msg {
    margin: 10px 0 10px 0;
    font-weight: bold;
  }
  .show-msg .title {
    font-size: larger;
    font-weight: 700;
    color: #0a8ede;
    line-height: 280%;
  }
</style>



// WEBPACK FOOTER //
// src/components/splitimg/index.vue